import {
  DataTablePrimeReact,
  PaginationERP,
  TableERP,
} from "@finanedi.es/storybook"
import { DevolucionReadingFilteredDtoProps } from "api/DTOs/DevolucionReadingFilteredDto"
import { PAGINATION_STYLES } from "constants/primereactStyles"
import { Dispatch, RefObject, SetStateAction } from "react"
import { useTranslation } from "react-i18next"

export interface TableDevolucionesIngresosProps {
  columns: any // eslint-disable-line @typescript-eslint/no-explicit-any
  dtRef: RefObject<DataTablePrimeReact<DevolucionReadingFilteredDtoProps[]>>
  items: Array<DevolucionReadingFilteredDtoProps>
  isLoading: boolean
  totalCount: number
  pagination: { itemsPerPage: number; skipCount: number }
  setPagination: Dispatch<
    SetStateAction<{ itemsPerPage: number; skipCount: number }>
  >
  sortField: string | undefined
  sortOrder: 1 | 0 | -1 | null | undefined
  selection: DevolucionReadingFilteredDtoProps[]
  setSelection: Dispatch<SetStateAction<DevolucionReadingFilteredDtoProps[]>>
  onSort: (e: {
    sortField: string | undefined
    sortOrder: 1 | 0 | -1 | null | undefined
  }) => void
}

export default ({
  columns,
  dtRef,
  items,
  isLoading,
  totalCount,
  pagination,
  setPagination,
  sortField,
  sortOrder,
  selection,
  setSelection,
  onSort,
}: TableDevolucionesIngresosProps) => {
  const { t } = useTranslation()

  return (
    <div className='tw-flex tw-flex-col tw-flex-1 tw-relative tw-h-full'>
      <div className='tw-h-[calc(100%-60px)]'>
        <TableERP
          refTable={dtRef}
          columns={columns}
          className='tw-h-full'
          columnResizeMode='expand'
          data-testid='tabla-devoluciones-pagos'
          id='tabla-devoluciones-pagos'
          sortField={sortField}
          sortOrder={sortOrder}
          onSort={onSort}
          removableSort
          value={items}
          showGridlines
          dataKey='id'
          lazy
          scrollable
          selection={selection}
          selectionMode='checkbox'
          size='small'
          selectionColumnMode='multiple'
          onSelectionChange={({
            value,
          }: {
            originalEvent: React.SyntheticEvent
            value: DevolucionReadingFilteredDtoProps[]
            type?: "multiple" | "all" | "checkbox" | "row" | undefined
          }) => {
            setSelection(value)
          }}
          loading={isLoading}
          emptyMessage={t("primeReact.table.emptyMessage")}
        />
      </div>
      <PaginationERP
        className={PAGINATION_STYLES}
        totalRecords={totalCount}
        first={pagination.skipCount}
        rows={pagination.itemsPerPage}
        resetScroll={() => dtRef.current && dtRef.current?.resetScroll()}
        setPagination={setPagination}
        optionDropdown={[10, 20, 50, 100]}
        texts={{
          textRowsPerPageDropdown: `${t("pagination.textRowsPag")}`,
          textCurrentPageReport: `${t("pagination.from")}`,
        }}
      />
    </div>
  )
}
